import styled from "styled-components";
import TextInput from "./TextInput";

const StyledInput = styled(TextInput)`
  ${props => props.attributeName === "postcode" && `text-transform: uppercase;`}
  max-width: 360px;
`;

export default StyledInput;
